(function() { window.GUID_8b9c4ab2_dcaa_4f31_ae6a_9ea9d5389243 = { getGuid: function() { return "8b9c4ab2-dcaa-4f31-ae6a-9ea9d5389243"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class FacebookShareButton extends Controls.Button {
            get Tool() { return this.tool; }
            constructor(buttonId, shareOption) {
                super(buttonId);
                this.shareOption = shareOption;
            }
            OnBindEvents() {
                super.OnBindEvents();
                if (this.shareOption == null) {
                    this.shareOption = this.$button.data('param');
                }
                this.tool = new FacebookShareButton.ShareTool(this.shareOption, (imageData) => { return this.alterImage(imageData); });
                Controls.Button.Events.Clicked({
                    selector: this,
                    callback: (c, e) => this.share(this, e)
                });
                CS.DOM.$body.offon('click.share', '#button-confirm', function (e) {
                    if (CS.CommonData.Current.IsNativeApp) {
                        CS.NativeApp.NA_ShareFacebookClicked($("#ShareUrl").val());
                    }
                    else {
                        if (typeof (FB) !== 'undefined') {
                            FB.ui({
                                method: 'share',
                                href: $("#ShareUrl").val(),
                            }, function (response) {
                                CS.Nav.GoBack();
                            });
                        }
                    }
                });
                CS.DOM.$body.offon('click.copy', '#button-clipboard', function (e) {
                    let text = $("#ShareUrl").val();
                    if (text != null && navigator.clipboard != undefined) {
                        navigator.clipboard.writeText(text).then(function () {
                            let $text = $("<div style='position:fixed; bottom: 40px; left: 50%; color: black; background-color:white; padding: 20px;'>Link copied to clipboard</div>");
                            $('body').append($text);
                            $text.show().delay(1000).fadeOut(300, () => { $text.remove(); });
                        });
                    }
                    e.preventDefault();
                });
            }
            alterImage(imageData) {
                let event = { imageData: imageData };
                this.Trigger(FacebookShareButton.EventNames.AfterImageGenerated, {
                    jqueryEventObject: null,
                    data: event
                });
                return event.imageData;
            }
            share(control, e) {
                CS.Analytics.Event('FacebookShareButton', 'Share', this.ControlId);
                this.Trigger(FacebookShareButton.EventNames.BeforeImageGenerated, {
                    jqueryEventObject: e.jqueryEventObject,
                    data: this.shareOption
                });
                this.tool.Share();
                this.Trigger(FacebookShareButton.EventNames.AfterImageGenerated, {
                    jqueryEventObject: e.jqueryEventObject,
                    data: this.shareOption
                });
            }
        }
        Controls.FacebookShareButton = FacebookShareButton;
        (function (FacebookShareButton) {
            class ShareTool {
                constructor(param, alterImage) {
                    this.param = param;
                    this.alterImage = alterImage;
                    if (!param)
                        return;
                    this.target = param.target;
                    this.canvas = param.canvas;
                    this.exclude = $(param.excludeSelector);
                    if (!alterImage)
                        this.alterImage = (imageData) => { return imageData; };
                }
                Share() {
                    console.info("share clicked");
                    if (!this.target)
                        this.target = document.querySelector(this.param.targetSelector);
                    if (this.target.tagName == "canvas" && !this.canvas)
                        this.canvas = this.target;
                    if (!this.canvas)
                        this.shareHtmlToCanvas();
                    else if (this.param.download)
                        this.DownloadCanvas(this.canvas);
                    else
                        this.ShareCanvas(this.canvas);
                }
                DownloadCanvas(canvas) {
                    let data = this.getImageData(canvas);
                    this.downloadURI(data, this.param.metaData.title + ".jpeg");
                }
                configureHtml2Canvas(target, bgColor) {
                    let useCrop = false;
                    let me = this;
                    if (this.param.useCropMethod)
                        useCrop = true;
                    // TODO : Fix Offset
                    // TODO : Christian (Fix offset)
                    target.addClass("shared-version");
                    let imgElements = target.find('img');
                    let promises = []; // Array to hold all promises for image loading and processing
                    // Create a canvas element
                    var imgCanvas = window.document.createElement('canvas');
                    //Because the images are on another domain, we need to set the crossOrigin attribute to handle CORS and redownload the images
                    imgElements.each((index, imgElement) => {
                        // Create a promise for each image load and process
                        let imgPromise = new Promise((resolve, reject) => {
                            let newImg = new Image();
                            newImg.crossOrigin = "anonymous"; // Set the crossOrigin attribute to handle CORS
                            newImg.onload = () => {
                                try {
                                    // Convert the image to Base64 once it is loaded
                                    let base64image = me.convertLoadedImageToBase64(imgCanvas, newImg);
                                    // Create a clone of the current img element without copying its attributes (like 'src').
                                    let clonedImg = imgElement.cloneNode(false);
                                    clonedImg.src = base64image;
                                    // Replace the original img element with the cloned one in the DOM
                                    $(imgElement).replaceWith($(clonedImg));
                                    resolve(null); // Resolve the promise after processing is done
                                }
                                catch (e) {
                                    console.error("Failed to load image with crossOrigin set. " + e);
                                    resolve(null); // Resolve the promise after processing is done
                                }
                            };
                            newImg.onerror = (e) => {
                                console.error("Failed to load image with crossOrigin set. " + e);
                                resolve(null); // Resolve the promise after processing is done
                            };
                            // Set the source last to ensure the load event can be caught
                            newImg.src = imgElement.src;
                        });
                        promises.push(imgPromise); // Add the promise to the array
                    });
                    // Use Promise.all to execute code after all images are processed
                    return Promise.all(promises).then(() => {
                        console.log("All images have been loaded and transformed to Base64.");
                        // Setup html2canvas options based on conditions
                        let options = {
                            backgroundColor: bgColor,
                            scale: 3,
                            //allowTaint: true,
                            //useCORS: true,
                            logging: true,
                        };
                        let canvasTarget = target[0];
                        if (useCrop) {
                            let offset = target.offset();
                            console.log("useCrop");
                            options.x = offset.left;
                            options.y = offset.top;
                            options.height = target.height();
                            options.width = target.width();
                            options.ignoreElements = (element) => {
                                let e = $(element);
                                if (e.hasClass("section-top") || e.hasClass("section-bottom") || e.hasClass("dont-share") || e.hasClass("dont-share-ignore-height"))
                                    return true;
                                for (var i = 0; i < me.exclude.length; i++) {
                                    if (element === me.exclude.get(i))
                                        return true;
                                }
                                return false;
                            };
                            canvasTarget = document.querySelector("html");
                        }
                        else {
                            var totalHiddenHeight = 0;
                            target.find('.dont-share').each(function (index) {
                                if ($(this).parents('.dont-share').length > 0) {
                                    return;
                                }
                                totalHiddenHeight += $(this).height();
                            });
                            //let offset = target.offset();
                            //let offsetParent = target.parent().offset();
                            //let diffX = (target.parent().width() - target.width() + this.target.clientLeft) / 8;
                            options.height = target.height() - totalHiddenHeight + 4;
                            options.ignoreElements = (element) => {
                                let e = $(element);
                                if (element.nodeName == "SCRIPT")
                                    return true;
                                if (e.hasClass("section-top") || e.hasClass("section-bottom") || e.hasClass("dont-share") || e.hasClass("dont-share-ignore-height"))
                                    return true;
                                for (var i = 0; i < me.exclude.length; i++) {
                                    if (element === me.exclude.get(i))
                                        return true;
                                }
                                return false;
                            };
                            options.onclone = (document) => {
                                //Enlever les animations pour que ca marche comme il faut
                                var elements = document.querySelectorAll('.xyz-in');
                                for (var i = 0; i < elements.length; i++) {
                                    elements[i].classList.remove('xyz-in');
                                }
                                $(document).find('img').attr('crossOrigin', 'anonymous');
                                $(document).find('.new-sticky').each((i, e) => {
                                    e.style.transform = null;
                                    let x = e.style.scrollMarginLeft;
                                    let y = e.style.scrollMarginTop;
                                    e.style.scrollMarginLeft = null;
                                    e.style.scrollMarginTop = null;
                                    if (x) {
                                        e.style.left = x;
                                    }
                                    if (y) {
                                        e.style.top = y;
                                    }
                                });
                            };
                            if (this.target.id.indexOf('event-wall') != -1) {
                                //Patch pour share de event-wall
                                //options.x = -offset.left + diffX;
                                //options.y = offset.top + 22.5;
                                options.scrollX = -window.scrollX - this.target.offsetLeft + 2; //Fix pour que l'élément soit au top
                                options.scrollY = -window.scrollY + this.target.offsetTop;
                            }
                            else {
                                options.scrollX = -window.scrollX - this.target.offsetLeft + 2; //Fix pour que l'élément soit au top
                                options.scrollY = -window.scrollY + this.target.offsetTop;
                                //    options.scrollX = -offset.left + diffX; //Fix pour que l'élément soit au top
                                //    options.scrollY = -offset.top - this.target.clientTop / 2 + this.target.offsetTop / 2;
                            }
                        }
                        let promise = html2canvas(canvasTarget, options);
                        target.removeClass("shared-version");
                        return promise;
                    }).catch(error => {
                        console.error("An error occurred:", error);
                        throw error; // Rethrow or handle as needed
                    });
                }
                convertLoadedImageToBase64(canvas, img) {
                    canvas.width = img.naturalWidth;
                    canvas.height = img.naturalHeight;
                    // Draw the image onto the canvas
                    var ctx = canvas.getContext('2d');
                    ctx.drawImage(img, 0, 0);
                    // Convert the canvas to a base64 string
                    var base64String = canvas.toDataURL('image/png'); // You can adjust the format
                    return base64String;
                }
                shareHtmlToCanvas() {
                    if (!this.target)
                        this.target = document.querySelector("html");
                    let $target = $(this.target);
                    let bgColor = this.rgb2hex($('body').css("background-color"));
                    let background = {
                        originalStyle: null,
                        target: null
                    };
                    if (this.param.fixBackgroundRelativeSelector) {
                        background.target = $(this.param.fixBackgroundRelativeSelector, $target);
                        background.originalStyle = background.target.attr("style");
                        background.target.css({ backgroundColor: bgColor });
                    }
                    var promise = this.configureHtml2Canvas($target, bgColor);
                    promise.then((canvas) => {
                        if (this.param.fixBackgroundRelativeSelector && background.target && background.target.length > 0) {
                            background.target.attr("style", background.originalStyle);
                        }
                        if (this.param.download)
                            this.DownloadCanvas(canvas);
                        else
                            this.ShareCanvas(canvas);
                    });
                }
                rgb2hex(rgb) {
                    if (/^#[0-9A-F]{6}$/i.test(rgb))
                        return rgb;
                    rgb = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
                    function hex(x) {
                        return ("0" + parseInt(x).toString(16)).slice(-2);
                    }
                    return "#" + hex(rgb[1]) + hex(rgb[2]) + hex(rgb[3]);
                }
                getImageData(canvas) {
                    if (this.param.quality)
                        return this.alterImage(canvas.toDataURL("image/jpeg", this.param.quality));
                    return this.alterImage(canvas.toDataURL("image/jpeg"));
                }
                ShareCanvas(canvas) {
                    let data = this.getImageData(canvas).replace("data:image/jpeg;base64,", "");
                    let meta = this.getPageMetaData();
                    let request = {
                        Data: data,
                        Description: meta.description,
                        Title: meta.title,
                        Url: meta.url,
                        SavePdfUrl: meta.savePdfUrl,
                    };
                    CS.Ajax.Post(CS.Url.CSUrl("facebookpost"), request, (response) => {
                        //CS.Nav.Go(Url.CSUrl("confirmshare"), response);
                    });
                }
                downloadURI(uri, name) {
                    let link = document.createElement("a");
                    link.download = name;
                    link.href = uri;
                    link.className = "external";
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
                dataURItoBlob(dataURI) {
                    let byteString = atob(dataURI.split(',')[1]);
                    let ab = new ArrayBuffer(byteString.length);
                    let ia = new Uint8Array(ab);
                    for (var i = 0; i < byteString.length; i++) {
                        ia[i] = byteString.charCodeAt(i);
                    }
                    return new Blob([ab], { type: 'image/jpeg' });
                }
                getPageMetaData() {
                    if (this.param && this.param.metaData)
                        if (this.param.metaData.description && this.param.metaData.title && this.param.metaData.url)
                            return this.param.metaData;
                    let title = document.title;
                    let description = "";
                    let url = document.location.pathname;
                    let descriptionMeta = document.querySelector('meta[property="og:description"]');
                    if (descriptionMeta == null)
                        descriptionMeta = document.querySelector('meta[name="description"]');
                    let titleMeta = document.querySelector('meta[property="og:title"]');
                    let urlMeta = document.querySelector('meta[property="og:url"]');
                    if (descriptionMeta)
                        description = descriptionMeta.content;
                    if (titleMeta)
                        title = titleMeta.content;
                    if (urlMeta)
                        url = urlMeta.content;
                    if (this.param && this.param.metaData) {
                        if (this.param.metaData.description)
                            description = this.param.metaData.description;
                        if (this.param.metaData.title)
                            title = this.param.metaData.title;
                        if (this.param.metaData.url)
                            url = this.param.metaData.url;
                    }
                    return { title, description, url };
                }
            }
            FacebookShareButton.ShareTool = ShareTool;
            class Events extends Controls.Button.Events {
                static BeforeImageGenerated(param) {
                    Controls.RegisterEvent(FacebookShareButton, EventNames.BeforeImageGenerated, param);
                }
                static AlterGeneratedImage(param) {
                    Controls.RegisterEvent(FacebookShareButton, EventNames.AlterGeneratedImage, param);
                }
                static AfterImageGenerated(param) {
                    Controls.RegisterEvent(FacebookShareButton, EventNames.AfterImageGenerated, param);
                }
            }
            FacebookShareButton.Events = Events;
            class EventNames extends Controls.Button.EventNames {
            }
            EventNames.BeforeImageGenerated = "facebooksharebutton-before_image_generated";
            EventNames.AlterGeneratedImage = "facebooksharebutton-alter-generated-image";
            EventNames.AfterImageGenerated = "facebooksharebutton-after_image_generated";
            FacebookShareButton.EventNames = EventNames;
        })(FacebookShareButton = Controls.FacebookShareButton || (Controls.FacebookShareButton = {}));
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=FacebookShareButton.js.map
